// @flow
export const ADD_EVENT = 'hive/schedules2/ADD_EVENT';
export const ADD_SCHEDULE_DATA = 'hive/schedules2/ADD_SCHEDULE_DATA';
export const ATTEMPT_SAVE_SCHEDULE = 'hive/schedules2/ATTEMPT_SAVE_SCHEDULE';
export const CANCEL_SAVE_SCHEDULE = 'hive/schedules2/CANCEL_SAVE_SCHEDULE';
export const CHANGE_MODE = 'hive/schedules2/CHANGE_MODE';
export const COMPLETE_SAVE_SCHEDULE = 'hive/schedules2/COMPLETE_SAVE_SCHEDULE';
export const COPY_DAY_EVENTS = 'hive/schedules2/COPY_DAY_EVENTS';
export const DELETE_EVENT = 'hive/schedules2/DELETE_EVENT';
export const DESELECT_SCHEDULE_DAY = 'hive/schedules2/DESELECT_SCHEDULE_DAY';
export const HIDE_POPUP = 'hive/schedules2/HIDE_POPUP';
export const OVERRIDE_SCHEDULE = 'hive/schedules2/OVERRIDE_SCHEDULE';
export const RESET_SCHEDULE = 'hive/schedules2/RESET_SCHEDULE';
export const SELECT_DAY = 'hive/schedules2/SELECT_DAY';
export const SELECT_EVENT = 'hive/schedules2/SELECT_EVENT';
export const SETUP_ACTION_FORM_SCHEDULE = 'hive/schedules2/SETUP_ACTION_FORM_SCHEDULE';
export const SHOW_POPUP = 'hive/schedules2/SHOW_POPUP';
export const UNDO_ALL = 'hive/schedules2/UNDO_ALL';
export const UPDATE_EVENT_START = 'hive/schedules2/UPDATE_EVENT_START';
export const UPDATE_EVENT_VALUE = 'hive/schedules2/UPDATE_EVENT_VALUE';
export const UPDATE_DAILY_START_TIMES = 'hive/schedules2/UPDATE_DAILY_START_TIMES';



// WEBPACK FOOTER //
// ./src/core/state/ui/schedule/constants.js